module.exports = __webpack_public_path__ + "static/img/20260605_2.d6e47fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20260605_2.jpg
// module id = wSxI
// module chunks = 100